import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import HomeView from '../views/HomeView.vue';

// 类型转换: 解决 ts2709错误问题
type RouteRecordRaw = typeof RouteRecordRaw;

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/hhb',
    name: 'hhb',
    component: () => import(/* webpackChunkName: "about" */ '../views/hhbView.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/news',
    name: 'news',
    component: () => import(/* webpackChunkName: "about" */ '../views/newsView.vue')
  },
  {
    path: '/breeze',
    name: 'breeze',
    component: () => import(/* webpackChunkName: "about" */ '../views/breezeView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
